import { CategoryInterface, NomenclatureGroupInterface } from '@/types'

import getPathForSelectedTreeNode from '../nodes/getPathForSelectedTreeNode'

export default function handleSelectTreeNode(
  tree: NomenclatureGroupInterface[] | CategoryInterface[],
  node: string
) {
  if (!tree || tree.length === 0 || !node) {
    return ''
  }

  if (tree[0] && 'nomenclatureGroup' in tree[0]) {
    const newTree = [...tree] as NomenclatureGroupInterface[]
    let nomenclatureGroupsPath = [] as NomenclatureGroupInterface[]
    nomenclatureGroupsPath = getPathForSelectedTreeNode(
      newTree,
      node,
      []
    ) as NomenclatureGroupInterface[]
    if (nomenclatureGroupsPath) {
      const path = nomenclatureGroupsPath
        .map(
          (item: NomenclatureGroupInterface) =>
            item.nomenclatureGroup.description
        )
        .join(' > ')
      return path
    } else {
      return ''
    }
  } else if (tree[0] && 'category' in tree[0]) {
    const newTree = [...tree] as CategoryInterface[]
    let categoriesPath = [] as CategoryInterface[]
    categoriesPath = getPathForSelectedTreeNode(
      newTree,
      node,
      []
    ) as CategoryInterface[]
    if (categoriesPath) {
      const path = categoriesPath
        .map((item: CategoryInterface) => item.category.description)
        .join(' > ')
      return path
    } else {
      return ''
    }
  }
}
